import React,{ Component } from "react";
import {connect} from "react-redux";
import { getKasmId} from "../../../actions/actionKasm";
import { Row, Col, Table, Card, CardBody, CardHeader} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Kasms",path:"/kasm",isActive: false},
    {name: "ViewKasm",path:"/viewkasm",isActive: true},
];

class ViewKasm extends Component{
    constructor(props){
        super(props);
    }
  
    componentDidMount(){
        this.props.getKasmId(this.props.match.params.id);
    }

    render(){
        const {kasm} = this.props;
        let url = "";
        if (kasm != null)
            url = "https://" + kasm.hostname + window.location.pathname  + "#/kasm/" + kasm.kasm_id.substring(0, 6);
        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                             <strong>Session</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                    <div className="profile-table">
                                            {kasm?
                                                <Table  className="card_table">             
                                                    <tbody>
                                                        <tr><td><h4>ID</h4></td><td>{kasm.kasm_id ? kasm.kasm_id : "-"}</td></tr>
                                                        <tr><td><h4>URL</h4></td><td><a href={url}>{url}</a></td></tr>
                                                        <tr><td><h4>Created</h4></td><td>{moment(kasm.created_date).isValid() ? moment(kasm.created_date).format("L h:mm A") : "-"}</td></tr>
                                                        <tr><td><h4>Assigned</h4></td><td>{kasm.start_date ? moment(kasm.start_date).format("L h:mm A"): ''}</td></tr>
                                                        <tr><td><h4>Expiration</h4></td><td>{moment(kasm.expiration_date).isValid() ? moment(kasm.expiration_date).format("L h:mm A") : "-"}</td></tr>
                                                        <tr><td><h4>Last Accessed</h4></td><td>{moment(kasm.keepalive_date).isValid() ? moment(kasm.keepalive_date).format("L h:mm A") : "-"}</td></tr>
						                                <tr><td><h4>IP Address </h4></td><td>{kasm.container_ip ? kasm.container_ip : "-"}</td></tr>
                                                        <tr><td><h4>Cores</h4></td><td>{kasm.cores ? kasm.cores : "-"}</td></tr>
                                                        <tr><td><h4>Memory</h4></td><td>{kasm.memory ? kasm.memory : "-"}</td></tr>
                                                        <tr><td><h4>Status</h4></td><td>{kasm.operational_status ? kasm.operational_status : "-"}</td></tr>
                                                        <tr><td><h4>Point of Presence</h4></td><td>{kasm.point_of_presence ? kasm.point_of_presence : "-"}</td></tr>
                                                    </tbody> 
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                        <Card >
                            <CardHeader>
                                <strong>Agent</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                        <div className="profile-table">
                                            {kasm && kasm.server ? 
                                                <Table className="card_table">       
                                                    <tbody>
                                                        <tr><td><h4>ID</h4></td><td>{kasm.server_id ? kasm.server_id : "-"}</td></tr>
                                                        <tr><td><h4>HostName</h4></td><td>{kasm.server.hostname ? kasm.server.hostname : "-"}</td></tr>
                                                        <tr><td><h4>Zone</h4></td><td>{kasm.server.zone_name ? kasm.server.zone_name : "-"}</td></tr>
                                                        <tr><td><h4>Provider</h4></td><td>{kasm.server.provider ? kasm.server.provider : "-"}</td></tr>
                                                    </tbody> 
                                                </Table>  :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>  
                        <Card >
                            <CardHeader>
                                <strong>Workspace</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                        <div className="profile-table">
                                            {kasm && kasm.image ?  
                                                <Table  className="card_table">             
                                                    <tbody>
                                                        <tr><td><h4>ID</h4></td><td>{kasm.image_id ? kasm.image_id : "-"}</td></tr>
                                                        <tr><td><h4>Docker Image</h4></td><td>{kasm.image.name ? kasm.image.name : "-"}</td></tr>
                                                        <tr><td><h4>Friendly Name</h4></td><td>{kasm.image.friendly_name ? kasm.image.friendly_name : "-"}</td></tr>
                                                    </tbody> 
                                                </Table>  :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>  
                        <Card >
                            <CardHeader>
                                <strong>User</strong>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                        <div className="profile-table">
                                            {kasm && kasm.image ?    
                                                <Table  className="card_table">           
                                                    <tbody>
                                                        <tr><td><h4>ID </h4></td><td>{kasm.user_id ? kasm.user_id : "-"}</td></tr>
                                                        <tr><td><h4>Name</h4></td><td>{kasm.user.username ? kasm.user.username : "-"}</td></tr>
                                                    </tbody> 
                                                </Table>   :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>  
                    </Col>
                </Row>
            </div>
        );}
}

ViewKasm.propTypes = {
    getKasmId: Proptypes.func.isRequired,
    kasm: Proptypes.object,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        kasm: state.kasms.kasm || null,
        getKasm_IdLoading: state.kasms.getKasm_IdLoading || false,
    }),
dispatch => 
    ({  
        getKasmId: (data) => dispatch(getKasmId(data)),
    }))(ViewKasm);
